import GameFrameButtons from "../frame-buttons";
import GameCurrencyAndMode from "../game-currency-and-mode";
import '../index.css'
import Loading from "../../../components/loading";
import {useEffect} from "react";
import FormButton from "../../../components/form-button";
import {useTranslation} from "react-i18next";
import SvgIcon from "../../../components/svg-icon";

const PlayGameWebFrameError = (props) => {

    const {
        error
    } = props


    return (
        <div className="frame__unavailable">
            <SvgIcon id={'lock-pin'}/>
            <span>
                               {error}
                          </span>
        </div>
    )


}

export default PlayGameWebFrameError
